<template>
  <div
    class="board-cell"
    :class="{
      'is-anchor': isAnchor,
      'is-path': hasPath,
      'is-blocked': isBlocked,
      'is-empty': cell.isEmpty,
      'needs-top-border': isFirstRow,
      'needs-left-border': isFirstCol,
      'empty-border-right': cell.isEmpty && rightHasContent,
      'empty-border-bottom': cell.isEmpty && bottomHasContent,
    }"
    :data-positionx="cell.positionx"
    :data-positiony="cell.positiony"
  >
    <shape-icon
      v-if="isAnchor"
      :shape="cell.shape"
      :color="cell.color"
      :value="cell.value"
      :filled="cell.filled"
      :size="iconSize"
      :settings="settings"
    />

    <shape-path
      v-else-if="hasPath"
      :direction="cell.direction"
      :color="activeColor"
      :pathWeight="settings.pathWeight"
    />

    <div
      v-if="shouldShowNumber"
      class="cell-number"
      :style="{ color: activeColor }"
    >
      {{ cell.value }}
    </div>
  </div>
</template>

<script>
import ShapeIcon from './elements/ShapeIcon.vue';
import ShapePath from './elements/ShapePath.vue';

export default {
  name: 'ShapeCell',
  components: {
    ShapeIcon,
    ShapePath,
  },
  props: {
    cell: { type: Object, required: true },
    cellSize: { type: Number, default: 60 },
    settings: { type: Object, required: true },
    topIsEmpty: { type: Boolean, default: false },
    leftIsEmpty: { type: Boolean, default: false },
    rightHasContent: { type: Boolean, default: false },
    bottomHasContent: { type: Boolean, default: false },
  },
  computed: {
    isFirstRow() {
      return this.cell.positiony === 0;
    },
    isFirstCol() {
      return this.cell.positionx === 0;
    },
    isAnchor() {
      return this.cell.shape !== null;
    },
    isBlocked() {
      return this.cell.isBlocked;
    },
    hasPath() {
      return this.settings.showAnswer && this.cell.direction !== null;
    },
    activeColor() {
      return this.settings.colored && this.cell.color
        ? this.cell.color
        : '#000000';
    },
    iconSize() {
      return Math.round(this.cellSize * 0.6);
    },
    shouldShowNumber() {
      if (this.isBlocked) return !!this.cell.value;

      return (
        this.cell.isResult ||
        (this.cell.value && this.settings.showAnswer && !this.isAnchor)
      );
    },
  },
};
</script>

<style scoped>
.board-cell {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-sizing: border-box;
  border-right: 2px solid #000;
  border-bottom: 2px solid #000;
  border-top: none;
  border-left: none;
}

.is-empty {
  border: none !important;
}

.is-result {
  font-weight: bold;
  font-size: 1.3rem;
  margin: 0 !important;
}

.empty-border-right {
  border-right: 2px solid #000 !important;
}

.empty-border-bottom {
  border-bottom: 2px solid #000 !important;
}

.board-cell.needs-top-border {
  border-top: 2px solid #000;
}

.board-cell.needs-left-border {
  border-left: 2px solid #000;
}

.is-blocked {
  background-color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.is-blocked .cell-number {
  color: #fff !important;
  font-size: 1.4rem;
  z-index: 2;
}

.is-blocked {
  border: 1px solid #000;
}

.cell-number {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-family: sans-serif;
  font-weight: bold;
  font-size: 1.3rem;
}
</style>
